





























import { Component, Vue } from "vue-property-decorator";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import XYGraph from "@/components/graphs/XYGraph.vue";

@Component({
  name: "CompanyPulse",
  components: { ApplicationLayout, XYGraph }
})
export default class CompanyPulse extends Vue {
  // ===== Store ===== //

  // ===== Props ===== //

  // ===== Data ===== //
  public pafUrl = process.env.VUE_APP_PAF_URL;
  public revUrl = process.env.VUE_APP_REVENUE_URL;

  public revSeries = [
    { xKey: "date", yKey: "gross_potential", name: "Gross — Occupied Units:", color: "#FFC107" },
    { xKey: "date", yKey: "actual_occupied", name: "Actual — Occupied Units:", color: "#8BC34A" },
    { xKey: "date", yKey: "effective_rate", name: "Effective Rate:", color: "#2E7D32" },
    { xKey: "date", yKey: "sq_ft_occupied", name: "Occupied Square Foot Percentage:", color: "#FB8C00", rightAxis: true }
  ];
  public revPafSeries = [
    { xKey: "date", yKey: "revenue_paf", name: "" }
  ];

  // ===== Methods ===== //

  // ===== Computed ===== //

  // ===== Lifecycle Hooks ===== //
}
